import { computed, get } from '@ember/object';

export default function trim(dependentKey) {
  return computed(dependentKey, function () {
    return get(this, dependentKey).trim();
  });
}
